import { Company, EntityType, Person } from "@mapmycustomers/shared/types/entity";

import TimelineAction from "@app/enum/TimelineAction";
import { RawTimelineEvent } from "@app/types/events/TimelineEvent";
import splitTimelineActions from "@app/util/timeline/splitTimelineActions";

export interface RecordAddedEntityRef {
  entityId: Company["id"] | Person["id"];
  entityType: EntityType.COMPANY | EntityType.PERSON;
}

// A record-added event whose entity IS the created company/person, which NewCompanyOrPersonEvent
// renders with a marker for that record. The raw action can be a comma-joined list, so match a
// member of it rather than the whole string. Returns undefined for every other event, including a
// check-in (its entity is the activity — see getCheckInEntityRef).
const getRecordAddedEntityRef = (event: RawTimelineEvent): RecordAddedEntityRef | undefined => {
  const entity = event.entity;
  if (!entity || !splitTimelineActions(event.action).includes(TimelineAction.RECORD_ADDED)) {
    return undefined;
  }
  return entity.entity === EntityType.COMPANY || entity.entity === EntityType.PERSON
    ? { entityId: entity.id, entityType: entity.entity }
    : undefined;
};

export default getRecordAddedEntityRef;
